import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'userGroup';

const userGroupService = {
  getRows: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/rows`,
      data,
    });
  },

  updateData: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteData: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  updateUserGroupUserLink: (userId, userGroupId) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/userGroupUserLink/${encodeURIComponent(userId)}/${encodeURIComponent(userGroupId)}`,
    });
  },
};
export default userGroupService;
